import { requester } from '../utils';

export const newReservationTiming = data => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: 'v1/schedule-reservation',
        method: 'POST',
        data,
        withAuth: true
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const editReservationTiming = data => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: 'v1/schedule-reservation',
        method: 'PUT',
        data,
        withAuth: true
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const getReservationTimingList = query => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/schedule-reservation/?${query}`,
        method: 'GET',
        withAuth: true
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const getReservationTimingDetails = id => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/schedule-reservation/${id}`,
        method: 'GET',
        withAuth: true
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const deleteReservationTimingByDay = id => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/schedule-reservation/${id}`,
        method: 'DELETE',
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};